const mediaItems = [
  {
    title: '《星际远征》官方预告 · 4K超清版',
    desc: '浩瀚宇宙中的史诗级冒险，4K HDR画质的视觉革命',
    duration: '02:35',
    views: '128万',
    imageSrc: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20movie%20trailer%20thumbnail%20with%20astronaut%20and%20spaceship%2C%20dramatic%20galaxy%20background%2C%20professional%20film%20cinematography%20style%2C%20epic%20scale%2C%20dark%20atmosphere%20with%20vibrant%20nebula%20colors%2C%20play%20button%20overlay&width=800&height=450&seq=mahua-media-01&orientation=landscape',
    imageAlt: '星际远征4K超清预告片',
  },
  {
    title: '蓝光画质对比 · 麻花影院 vs 普通平台',
    desc: '一镜到底实测，看看4K蓝光画质的真正实力',
    duration: '05:12',
    views: '96万',
    imageSrc: 'https://readdy.ai/api/search-image?query=Professional%20video%20quality%20comparison%20thumbnail%20with%20split%20screen%20cinematic%20footage%2C%20high%20definition%20vs%20standard%20quality%20visual%2C%20warm%20theater%20lighting%2C%20film%20review%20style%20design%2C%20clean%20professional%20look&width=800&height=450&seq=mahua-media-02&orientation=landscape',
    imageAlt: '蓝光画质对比评测视频',
  },
  {
    title: '《长安十二时辰》幕后特辑',
    desc: '揭秘4K修复技术如何让经典华语电影重焕光彩',
    duration: '08:47',
    views: '73万',
    imageSrc: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20production%20thumbnail%20with%20film%20crew%20and%20traditional%20Chinese%20costumes%2C%20warm%20golden%20lighting%2C%20cinematic%20documentary%20style%2C%20professional%20film%20making%20atmosphere&width=800&height=450&seq=mahua-media-03&orientation=landscape',
    imageAlt: '长安十二时辰幕后特辑',
  },
  {
    title: '七月观影指南 · 麻花影院编辑推荐',
    desc: '本月最值得看的10部超清大片，一部都不能错过',
    duration: '12:20',
    views: '156万',
    imageSrc: 'https://readdy.ai/api/search-image?query=Movie%20recommendation%20show%20thumbnail%20with%20film%20posters%20collage%2C%20warm%20cinematic%20lighting%2C%20professional%20review%20style%20design%2C%20clean%20modern%20layout%2C%20inviting%20theater%20atmosphere&width=800&height=450&seq=mahua-media-04&orientation=landscape',
    imageAlt: '七月观影指南编辑推荐',
  },
  {
    title: '如何选择最佳观影设备 · 4K观影指南',
    desc: '从电视到投影，教你搭建家庭4K影院的最佳方案',
    duration: '15:03',
    views: '89万',
    imageSrc: 'https://readdy.ai/api/search-image?query=Home%20theater%20setup%20guide%20thumbnail%20with%20modern%20living%20room%20and%20large%20TV%20screen%2C%20cozy%20cinema%20atmosphere%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20review%20style%2C%20clean%20contemporary%20design&width=800&height=450&seq=mahua-media-05&orientation=landscape',
    imageAlt: '最佳观影设备选择指南',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-play-circle-line text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">精彩视频</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              精彩预告
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              精选预告、幕后特辑与观影指南，一睹为快
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.slice(0, 3).map((item) => (
              <div key={item.title} className="group cursor-pointer">
                <div className="relative rounded-xl overflow-hidden mb-3 aspect-video">
                  <img
                    src={item.imageSrc}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-primary-600 text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 bg-black/70 backdrop-blur-sm text-white text-[10px] px-2 py-0.5 rounded-md whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3">
                  <p className="text-foreground-500 text-xs truncate flex-1">{item.desc}</p>
                  <span className="text-foreground-400 text-[10px] whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
              </div>
            ))}

            {mediaItems.slice(3).map((item) => (
              <div key={item.title} className="group cursor-pointer sm:col-span-2 lg:col-span-2">
                <div className="flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200/50 transition-colors duration-200">
                  <div className="relative rounded-lg overflow-hidden sm:w-64 flex-shrink-0 aspect-video sm:aspect-auto">
                    <img
                      src={item.imageSrc}
                      alt={item.imageAlt}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                      <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-play-fill text-primary-600 text-lg ml-0.5"></i>
                      </div>
                    </div>
                    <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-white text-[10px] px-2 py-0.5 rounded-md whitespace-nowrap">
                      {item.duration}
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-1.5 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-foreground-500 text-xs leading-relaxed mb-2">{item.desc}</p>
                    <span className="text-foreground-400 text-[10px]">
                      <i className="ri-eye-line mr-1"></i>{item.views}次观看
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}